import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

const SummaryRow = ({ label, value }: { label: string; value: string }) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween" width="full">
      <Text.Normal>{label}</Text.Normal>
      <Text.Normal weight="medium">{value}</Text.Normal>
    </Box>
  )
}

const SummaryBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box flexDirection="column" gap="s1" width="full">
      {children}
    </Box>
  )
}

interface SummarySectionProps {
  title: string
  small?: boolean
  children: React.ReactNode
}

const SummarySection = ({ title, children, small }: SummarySectionProps) => {
  return (
    <Box flexDirection="column" gap={small ? 's6' : 's1'}>
      <Text.Normal weight="semibold" size={small ? '200' : '300'}>
        {title}
      </Text.Normal>
      <SummaryBody>{children}</SummaryBody>
    </Box>
  )
}

export { SummaryRow, SummarySection }
export type { SummarySectionProps }
